import { render, staticRenderFns } from "./tenuta-la-giustiniana.vue?vue&type=template&id=4f2efd9a&scoped=true"
import script from "./tenuta-la-giustiniana.vue?vue&type=script&lang=js"
export * from "./tenuta-la-giustiniana.vue?vue&type=script&lang=js"
import style0 from "./tenuta-la-giustiniana.vue?vue&type=style&index=0&id=4f2efd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2efd9a",
  null
  
)

export default component.exports